import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import type { User } from "../types";

interface Props {
  children: React.ReactNode;
  /** Required role(s). Admin always passes. */
  roles?: User["role"][];
}

function homeForRole(role: User["role"]): string {
  switch (role) {
    case "instructor":
      return "/tutor";
    case "admin":
      return "/admin";
    default:
      return "/learn";
  }
}

export function ProtectedRoute({ children, roles }: Props) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }

  // Admin always passes
  if (roles && user.role !== "admin" && !roles.includes(user.role)) {
    return <Navigate to={homeForRole(user.role)} replace />;
  }

  return <>{children}</>;
}
